export default __webpack_public_path__ + "static/media/gallery_08.f841baf2.jpg";